import React from "react";
import { styled, Theme } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import { Button, FormHelperText } from "@mui/material";
import { SxProps } from "@mui/system";
import { useFormContext } from "react-hook-form";

const PREFIX = "UploadButton";

const classes = {
  button: `${PREFIX}-button`,
  input: `${PREFIX}-input`,
};

// TODO jss-to-styled codemod: The Fragment root was replaced by div. Change the tag if needed.
const Root = styled("div")(({ theme }) => ({
  [`& .${classes.button}`]: {
    textTransform: "none",
  },

  [`& .${classes.input}`]: {
    display: "none",
  },
}));

export function UploadButton(props: {
  handleFileUpload: (file: File) => void;
  title?: string;
  sx?: SxProps<Theme>;
  multiple?: boolean;
  mediaType?: string;
  required?: boolean;
  disabled?: boolean;
  name: string;
}) {
  const { t } = useTranslation();
  const { formState } = useFormContext<any>();

  return (
    <Root>
      <>
        <input
          accept={props.mediaType || "*/*"}
          style={{
            display: "none",
          }}
          id="contained-button-file"
          multiple={props.multiple}
          required={props.required}
          disabled={props.disabled}
          type="file"
          onChange={(event) => event.target.files && event.target.files[0] && props.handleFileUpload(event.target.files[0])}
        />
        <label htmlFor="contained-button-file">
          <Button
            color={"secondary"}
            variant={"contained"}
            disabled={props.disabled}
            component="span"
            sx={{
              ...props.sx,
              textTransform: "none",
            }}
          >
            {props.title || t("buttons.uploadCompanyLogo")}
          </Button>
        </label>
        {!formState.errors[props.name]?.message && <FormHelperText error={false}>{t("Company.logoHint")}</FormHelperText>}
        {formState.errors[props.name]?.message &&
          <FormHelperText error={true}>{formState.errors[props.name]?.message?.toString()}</FormHelperText>}
      </>
    </Root>
  );
}
